<div class="lmo-reassign-vendor">
  <h3>
    Reassign {{ (currentOrder$ | async).saUniqueId }}
    to a different vendor?
  </h3>

  <mat-form-field>
    <mat-label>Select Vendor</mat-label>
    <mat-select [formControl]="vendor" saAutomatedSelector="lmo_reassign_vendor__vendor_selector">
      <mat-option *ngFor="let vendor of truckingVendors$ | async" [value]="vendor">
        {{ vendor.truckingVendorName }} ({{ vendor.allocationPercent }}% Allocation)
      </mat-option>
    </mat-select>
  </mat-form-field>

  <div class="confirm" *ngIf="vendor.value" [@slideInAndOut]>
    Reassign load No. <strong>{{ (currentOrder$ | async).loadNumber }}</strong> to
    <strong>{{ vendor.value.truckingVendorName }}</strong
    >?

    <div class="button-row">
      <button mat-stroked-button color="warn" mat-dialog-close>
        No
      </button>
      <button
        mat-stroked-button
        color="primary"
        (click)="reassign()"
        saAutomatedSelector="lmo_reassign_vendor__yes_button"
      >
        Yes
      </button>
    </div>
  </div>
</div>
